export const CRIMINAL_APPELLATE_CATEGORY_ID = 'aeff7e28-36c7-4ff7-bf0b-c23ba5068a80';
export const CRIMINAL_APPELLATE_CATEGORY_CODE = 'CRIMINAL_APPEAL';

export const CRIMINAL_APPELLATE_WIZARD_STEPS = [
  { n: 1 as const, lbl: 'Case Overview' },
  { n: 2 as const, lbl: 'Party Details' },
  { n: 3 as const, lbl: 'Timeline' },
  { n: 4 as const, lbl: 'Submission & Physical File Delivery' },
  { n: 5 as const, lbl: 'Upload Documents' },
];
